import { VarExpression, VarExpressionType } from "@@expressions";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { IExpressionEvaluatorWithAssign } from "../../Models/IExpressionEvaluatorWithAssign";

export class VarExpressionEvaluator implements IExpressionEvaluatorWithAssign<VarExpression> {
  get type(): string {
    return VarExpressionType;
  }

  evaluate(expression: VarExpression, context: IExpressionEvaluatorContext): any {
    // Delegate the path traversal to the VariableScope
    const result = context.VariableScope.tryGet(expression.Value);
    //console.log(`VarExpressionEvaluator for path ${expression.Value.join(".")} result:`, result);
    return result;
  }

  assign(expression: VarExpression, context: IExpressionEvaluatorContext, value: any, path?: string[]): void {
    // Delegate the path traversal and assignment to the VariableScope

    const targetPath = path && path.length > 0 ? [...expression.Value, ...path] : expression.Value;

    context.VariableScope.set(targetPath, value);
    console.log("[VarExpressionEvaluator] Assigned value to variable:", targetPath.join("."), value, context.VariableScope);
  }
}



